import { ConfigMixin } from "@/mixins/ConfigMixin";

export const CartMixin = {
  mixins: [ConfigMixin],
  methods: {
    gotToPaymentPage(paymentUrl) {
      document.location.href = `${this.osvConfig.paths.cartPayment}?payment-url=${paymentUrl}`;
    },

    goToConfirmationPage(purchaseReference) {
      document.location.href = `${this.osvConfig.paths.cartPayment}?purchase-reference=${purchaseReference}`;
    },

    // Get facebook click trackers on cookies
    getAnalyticsTrackers() {
      const trackers = {};
      const cookies = document.cookie.split("; ");
      const fbc = cookies.find(row => row.startsWith("_fbc="))?.split("=")[1];

      if (fbc) {
        trackers.facebook = { fbc };
      }

      return trackers;
    }
  }
};
